module.exports = __webpack_public_path__ + "img/bldc_cmp2.eb8db3f7.png";